export enum GameCenterEmitMessage {
  ENGINE_UPDATE_STATUS = 'ENGINE_UPDATE_STATUS',
  ENGINE_GAME_OVER_SCORE = 'ENGINE_GAME_OVER_SCORE',
}